import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/login/Login";
import { AuthProvider } from "./context/AuthContext";
import BasicRequireAuth from "./components/login/BasicRequireAuth";
import * as authTypes from "./constants/authTypes";
import Unauthorised from "./components/Unauthorised";

interface BasicAuthWrapperProps {
  children: JSX.Element;
}

const BasicAuthWrapper = ({ children }: BasicAuthWrapperProps) => {
  return (
    <BrowserRouter>
      <AuthProvider authType={authTypes.BASIC}>
        <Routes>
          <Route path="/unauthorised" element={<Unauthorised />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<BasicRequireAuth>{children}</BasicRequireAuth>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default BasicAuthWrapper;
